var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-center ma-8"},[_c('div',{staticClass:"pseudo-app lighten-3 grey"}),_c('v-img',{staticClass:"pseudo-app",attrs:{"src":"/img/addToHomeScreen/app-icon-round-120x120.png","width":"80"}}),_c('div',{staticClass:"pseudo-app lighten-3 grey"}),_c('div',{staticClass:"pseudo-app lighten-4 grey"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }